export enum LogScope {
  General = 'GENERAL',
  Settings = 'SETTINGS',
  Alarms = 'ALARMS',
  HttpRequest = 'HTTP_REQUEST',
  ReactiveState = 'REACTIVE_STATE',
  Mappers = 'MAPPERS',
}
